import { render, staticRenderFns } from "./OtsTableGroup.vue?vue&type=template&id=5422e8a8&"
import script from "./OtsTableGroup.vue?vue&type=script&lang=js&"
export * from "./OtsTableGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports